import {Component} from 'react';
import SliderPanel from "../BaseLayout/SliderPanel.mjs";
import ListIcon from "../../media/images/ListIcon.mjs";
import TextLabel from '../../controls/TextLabel/TextLabel.mjs';
import "./Simulations.css";
import Glob from '../../libs/Glob.mjs';
import appLib from '../../libs/appLib.mjs';
import {Button} from 'reactstrap';
import AppCreateNewIcon from "../../media/app-images/AppCreateNewIcon.mjs";
import SimulationsList from "../../ComponentParts/Simulations/SimulationsList.mjs";

const prefix = "Simulations";

const Simulations = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clean: true
		};

		this.uid = Glob.generateUid(prefix);
	}

	componentDidMount() {
		Glob.setStatus('pageTitle', ['Simulations', 'Available simulations']);
		Glob.setStatus('pageIcon', <ListIcon/>);
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if (ll !== this.state.ll) this.setState({ll: ll});
		}, this.uid);
	}

	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	render() {
		return (
			<SliderPanel
				title={ <TextLabel value={"Available simulations"} /> }
				icon={ <ListIcon/> }
				className={ prefix }
			>
				<div className={"panel-content limited"}>
					<SimulationsList
						onClick={ (s)=>{ Glob.gotoPage({name: 'SimulationFlowEdit', params: {simul: s.id }}); } }
					/>
				</div>
				<div className={"panel-footer"}>
					<Button
						hidden={ ! appLib.enabled() }
						className={'btn-icon'}
						color={"success"}
						onClick={() => { Glob.gotoPage('SimulationFlowNew'); }}
					>
						<b>
							<TextLabel value={"New Simulation"} />
						</b>
						<i>
							<AppCreateNewIcon/>
						</i>
					</Button>
				</div>
			</SliderPanel>
		)
	}

}
export default Simulations;
